import { useEffect, useState } from 'react';
import { Flags, syncIntercom, useBreakpoints, useFlag } from 'ui';
import { FirebaseAuth, User } from 'services/FirebaseService/auth';

export function useMessengerInit() {
  const [user, setUser] = useState<User | null>(null);
  const intercomEnabled = useFlag(Flags.intercomEnabled);
  const { isMdUp } = useBreakpoints();

  useEffect(() => {
    const unsubscribe = FirebaseAuth.subscribeToUser((authUser) => {
      setUser(authUser as User | null);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (
      import.meta.env.VITE_APP_ENV !== 'prod' &&
      import.meta.env.VITE_APP_ENV !== 'stg'
    ) {
      return;
    }

    syncIntercom({
      user,
      enabled: intercomEnabled,
      alignment: isMdUp ? 'right' : 'left',
    });
  }, [intercomEnabled, user, isMdUp]);
}
